/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FoundKnowledgeGraphValue model module.
 * @module model/FoundKnowledgeGraphValue
 * @version 2.8.0
 */
class FoundKnowledgeGraphValue {
    /**
     * Constructs a new <code>FoundKnowledgeGraphValue</code>.
     * @alias module:model/FoundKnowledgeGraphValue
     * @extends Object
     * @param item {String} 
     * @param itemLabel {String} 
     * @param numberOfRelationshipsFound {Number} 
     * @param indexesOfRelationshipsFound {Array.<Number>} 
     */
    constructor(item, itemLabel, numberOfRelationshipsFound, indexesOfRelationshipsFound) { 
        
        FoundKnowledgeGraphValue.initialize(this, item, itemLabel, numberOfRelationshipsFound, indexesOfRelationshipsFound);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, item, itemLabel, numberOfRelationshipsFound, indexesOfRelationshipsFound) { 
        obj['item'] = item;
        obj['itemLabel'] = itemLabel;
        obj['numberOfRelationshipsFound'] = numberOfRelationshipsFound;
        obj['indexesOfRelationshipsFound'] = indexesOfRelationshipsFound;
    }

    /**
     * Constructs a <code>FoundKnowledgeGraphValue</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FoundKnowledgeGraphValue} obj Optional instance to populate.
     * @return {module:model/FoundKnowledgeGraphValue} The populated <code>FoundKnowledgeGraphValue</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FoundKnowledgeGraphValue();

            ApiClient.constructFromObject(data, obj, 'Object');
            

            if (data.hasOwnProperty('isValueProperty')) {
                obj['isValueProperty'] = ApiClient.convertToType(data['isValueProperty'], 'Boolean');
            }
            if (data.hasOwnProperty('isUrlProperty')) {
                obj['isUrlProperty'] = ApiClient.convertToType(data['isUrlProperty'], 'Boolean');
            }
            if (data.hasOwnProperty('isItemProperty')) {
                obj['isItemProperty'] = ApiClient.convertToType(data['isItemProperty'], 'Boolean');
            }
            if (data.hasOwnProperty('isMediaProperty')) {
                obj['isMediaProperty'] = ApiClient.convertToType(data['isMediaProperty'], 'Boolean');
            }
            if (data.hasOwnProperty('item')) {
                obj['item'] = ApiClient.convertToType(data['item'], 'String');
            }
            if (data.hasOwnProperty('itemLabel')) {
                obj['itemLabel'] = ApiClient.convertToType(data['itemLabel'], 'String');
            }
            if (data.hasOwnProperty('numberOfRelationshipsFound')) {
                obj['numberOfRelationshipsFound'] = ApiClient.convertToType(data['numberOfRelationshipsFound'], 'Number');
            }
            if (data.hasOwnProperty('indexesOfRelationshipsFound')) {
                obj['indexesOfRelationshipsFound'] = ApiClient.convertToType(data['indexesOfRelationshipsFound'], ['Number']);
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} isValueProperty
 */
FoundKnowledgeGraphValue.prototype['isValueProperty'] = undefined;

/**
 * @member {Boolean} isUrlProperty
 */
FoundKnowledgeGraphValue.prototype['isUrlProperty'] = undefined;

/**
 * @member {Boolean} isItemProperty
 */
FoundKnowledgeGraphValue.prototype['isItemProperty'] = undefined;

/**
 * @member {Boolean} isMediaProperty
 */
FoundKnowledgeGraphValue.prototype['isMediaProperty'] = undefined;

/**
 * @member {String} item
 */
FoundKnowledgeGraphValue.prototype['item'] = undefined;

/**
 * @member {String} itemLabel
 */
FoundKnowledgeGraphValue.prototype['itemLabel'] = undefined;

/**
 * @member {Number} numberOfRelationshipsFound
 */
FoundKnowledgeGraphValue.prototype['numberOfRelationshipsFound'] = undefined;

/**
 * @member {Array.<Number>} indexesOfRelationshipsFound
 */
FoundKnowledgeGraphValue.prototype['indexesOfRelationshipsFound'] = undefined;






export default FoundKnowledgeGraphValue;

